import {ClearOutlined, CheckOutlined} from '@material-ui/icons'
import {Container} from './components/Container'

type ValidationResultProps = {
  erroneous: boolean
  validation: React.ReactNode
}

export const ValidationResult = ({erroneous, validation}: ValidationResultProps) => (
  <Container>
    {erroneous ? <ClearOutlined fontSize="small" htmlColor="#F44336" /> : <CheckOutlined fontSize="small" htmlColor="#4CAF50" />}
    {validation}
  </Container>
)
